/** @jsxImportSource @emotion/react */
import { PracticeTestTypeEnum } from '__generatedTypes__/globalTypes'
import { InPersonMockResults } from './InPersonMockResults'

export type ResultsProps = {
  platformId: string
  type: PracticeTestTypeEnum
  practiceTestId: string
}

export const Results = ({ platformId, practiceTestId, type }: ResultsProps) => {
  const isInPersonTest = [PracticeTestTypeEnum.InPersonMockTest].includes(type)

  if (isInPersonTest) {
    return <InPersonMockResults platformId={platformId} practiceTestId={practiceTestId} />
  }

  return null
}
